import { useTranslate } from '@refinedev/core';
import { TextField } from '@refinedev/antd';
import { Typography } from 'antd';
import type { ContentEbookOut } from '@/api/generated/schemas';

const { Title } = Typography;

export const ProductEbookTab = ({
  ebook,
}: {
  ebook: ContentEbookOut | null | undefined;
}) => {
  const t = useTranslate();

  if (!ebook) {
    return (
      <Typography.Text type="secondary">
        {t('content_catalog.products.ebook.not_available')}
      </Typography.Text>
    );
  }

  return (
    <>
      <Title level={4}>{t('content_catalog.products.tabs.ebook')}</Title>

      {ebook.id != null && (
        <>
          <Title level={5}>{t('base.fields.id')}</Title>
          <TextField value={ebook.id} />
        </>
      )}

      {ebook.pages != null && (
        <>
          <Title level={5}>
            {t('content_catalog.products.ebook.fields.pages')}
          </Title>
          <TextField value={ebook.pages} />
        </>
      )}

      {ebook.characters != null && (
        <>
          <Title level={5}>
            {t('content_catalog.products.ebook.fields.characters')}
          </Title>
          <TextField value={ebook.characters} />
        </>
      )}
    </>
  );
};
